import { useQuery, QueryResult, useQueryClient } from '@eika-infrastruktur/react-query';

import type { AccountProperty } from '../generated-types';
import { getAccountProperties } from '../services/accountService';

const queryKey = ['get-account-properties'];
export function useAccountsPropertiesQuery(): QueryResult<AccountProperty[]> {
    return useQuery<AccountProperty[]>({
        queryKey,
        queryFn: getAccountProperties,
    });
}

export const useRefreshAccountProperties = () => {
    const queryClient = useQueryClient();

    return () => {
        queryClient.invalidateQueries({ queryKey });
    };
};
